import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);

export const detectedBrowser = {
  browserName: browser.getBrowserName(),
  browserVersion: browser.getBrowserVersion(),
  browserPlatformType: browser.getPlatformType(true),
};
